// Central test IDs (extend for astrology app)
export const HOME = {
  emergentLink: "home-emergent-link",
};

export const AUTH = {
  loginBtn: "login-google-btn",
  logoutBtn: "logout-btn",
  userAvatar: "user-avatar",
};

export const PROFILE = {
  createBtn: "create-profile-btn",
  nameInput: "profile-name-input",
  dobInput: "profile-dob-input",
  tobInput: "profile-tob-input",
  placeInput: "profile-place-input",
  ayanamshaSelect: "profile-ayanamsha-select",
  saveBtn: "profile-save-btn",
  placeSuggestion: "place-suggestion",
  card: "profile-card",
  deleteBtn: "profile-delete-btn",
};

export const DASH = {
  tabCharts: "tab-charts",
  tabStrengths: "tab-strengths",
  tabDasha: "tab-dasha",
  tabDay: "tab-day",
  tabHomeopathy: "tab-homeopathy",
  pdfExportBtn: "pdf-export-btn",
  daySelect: "day-date-input",
  dayFetchBtn: "day-fetch-btn",
  vargaSelect: "varga-select",
  refreshHomeo: "refresh-homeo-btn",
};
